import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

import { AppConfig } from '../../utils/app-config.service';
import { LocalStorage } from '../helpers/local-storage';
import { Session } from '../../domain/data';
import { SessionClientInterface, SessionInterface } from '../../../core';

import { environment } from '../../../../environments/environment';

@Injectable()
export class SessionClient implements SessionClientInterface {
    constructor(private localStorage: LocalStorage) {}

    create(): Observable<SessionInterface> {
        return new Observable((observer: Observer<Session>) => {
            let code = this.localStorage.userCode || '';

            if (environment.portalClient) {
                code = this.localStorage.clientCode || '';
            }

            const session = new Session(
                code,
                this.localStorage.domain || AppConfig.settings.domain,
                this.localStorage.language || AppConfig.settings.language,
                this.localStorage.sessionToken || '',
                this.localStorage.administrator,
                this.localStorage.isPBC
            );

            observer.next(session);
            observer.complete();
        });
    }
}
